import { useMutation } from 'react-query'
import HttpRequest from '@/config/axios.config'
import { UPLOAD_DOCUMENTS_ENDPOINT } from '@/constant/common'

export const useMaskUpdateTaskCheckUpdatable = () => {
  const api = async (payload: any) => {
    try {
      const response = await HttpRequest.post(
        'tasks/check-mass-update',
        payload
      )
      return response?.data
    } catch (error) {
      throw error
    }
  }
  return useMutation((data: any) => api(data))
}

export const useMassCommentTasks = () => {
  const api = async (payload: any) => {
    try {
      const response = await HttpRequest.post('/tasks/mass-comment', payload)
      return response?.data
    } catch (error) {
      throw error
    }
  }
  return useMutation((data: any) => api(data))
}

export const useMassUploadDocumentTasks = () => {
  const uploadMutation = useMutation(
    async (payload: any[]) => {
      let _formData = new FormData()
      payload.forEach((item) => _formData.append('files', item))

      HttpRequest.put['Content-Type'] = 'multipart/form-data'

      return HttpRequest.post(UPLOAD_DOCUMENTS_ENDPOINT, _formData).then(
        (resp) => (resp.data?.data ? resp.data?.data : [])
      )
    },
    {
      onSuccess: () => {},
      onError: () => {},
    }
  )
  const api = async (payload: any) => {
    try {
      const docs = await uploadMutation.mutateAsync(payload.fileList as any[])

      const documents = docs?.map((values) => {
        return { ...values, url_path: values.url, table: 'documents' }
      })
      const response = await HttpRequest.post('tasks/mass-upload', {
        documents,
        tasks: payload.tasks,
      })
      return response?.data
    } catch (error) {
      throw error
    }
  }
  return useMutation((data: any) => api(data))
}

export const useMassStatusTasks = () => {
  const api = async (payload: any) => {
    try {
      const response = await HttpRequest.put(
        'tasks/mass-update-status',
        payload
      )
      return response?.data
    } catch (error) {
      throw error
    }
  }
  return useMutation((data: any) => api(data))
}
